import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	gap: 10px;
`;

const StyledLabel = styled(Text)`
	flex-shrink: 0;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	color: rgba(255, 255, 255, 0.5);
`;

const StyledValueSlot = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	min-width: 0;

	& > ${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledIconSlot = styled.div`
	display: flex;
	align-items: center;
	flex-shrink: 0;
`;

export { StyledIconSlot, StyledLabel, StyledRow, StyledValueSlot };
